import { render } from "./VotesTableSubject.vue?vue&type=template&id=30a8b781"
import script from "./VotesTableSubject.vue?vue&type=script&lang=js"
export * from "./VotesTableSubject.vue?vue&type=script&lang=js"

import "./VotesTableSubject.vue?vue&type=style&index=0&id=30a8b781&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__